// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import React, { useEffect, useMemo, useState } from 'react';
import { FormattedMessage} from 'react-intl';
import { Node, NodeCue, parseSync } from 'subtitle';
import { Subtitles, SubtitlesLang } from '../../../../types/Model';
import Dropup from '../Dropup';
import S from './styles';

const SUBTITLE_MAP = {
  [SubtitlesLang.ENGLISH]: 'English',
  [SubtitlesLang.CHINESE_TRADITIONAL]: '中文',
  [SubtitlesLang.NONE]: '關閉字幕',
}

interface SubtitleProps {
  subtitles: Subtitles;
  playedSeconds: number;
  onSubtitleChange: (subtitleData: string) => void;
}

function useCueSubtitles(subtitles: Subtitles) {
  return useMemo(() => {
    const cueSubtitles: { [key: string]: NodeCue[] } = {};

    function isNodeCue(node: Node): node is NodeCue {
      return node.type === 'cue';
    }

    for (const key in subtitles) {
      const subtitle = subtitles[key];
      const cueSubtitle = parseSync(subtitle).filter(isNodeCue);
      cueSubtitles[key] = cueSubtitle;
    }

    return cueSubtitles;
  }, [subtitles]);
}

const Subtitle: React.FC<SubtitleProps> = (props) => {
  const {
    subtitles,
    playedSeconds,
    onSubtitleChange,
  } = props;

  const [lang, setLang] = useState(SubtitlesLang.NONE);

  const cueSubtitles = useCueSubtitles(subtitles);

  useEffect(() => {
    if (subtitles) {
      const currentSubtitle = cueSubtitles[lang];
      if (currentSubtitle) {
        const currentNowSubtitle = currentSubtitle.filter(current =>
          current.data.start <= playedSeconds * 1000 &&
          current.data.end >= playedSeconds * 1000).map(value => value.data.text).join(' ')
          ;
        onSubtitleChange(currentNowSubtitle);
      }
    }
  }, [playedSeconds])

  const subtitleOptions = [
    ...(Object.keys(subtitles || {}) as SubtitlesLang[]).filter((subtitle) =>
      Object.values(SubtitlesLang).indexOf(subtitle) !== -1
    ),
    SubtitlesLang.NONE
  ]

  useEffect(() => {
    if (lang === SubtitlesLang.NONE) {
      onSubtitleChange('')
    }
  }, [lang]);

  const parseSubtitlesType = (subtitleType: SubtitlesLang): JSX.Element => {
    return <>{SUBTITLE_MAP[subtitleType]}</>
  }

  const renderSubtitleButton = (handleTrigger?: () => void) => {
    const handleClickToggleSubtitle = () => {
      if (lang === SubtitlesLang.NONE) {
        setLang(subtitleOptions[0])
      } else {
        setLang(SubtitlesLang.NONE)
      }
    }

    return (
      <S.SubtitlesContainer>
        <S.TooltipsContainer>
          {subtitleOptions.length === 1 && <S.Tooltips><FormattedMessage id="F025" /></S.Tooltips>}
        </S.TooltipsContainer>
        <S.SubtitlesIcon
          disable={subtitleOptions.length === 1 || lang === SubtitlesLang.NONE}
          onClick={handleClickToggleSubtitle}
          onMouseEnter={handleTrigger}
        />
      </S.SubtitlesContainer>
    )
  }

  return subtitleOptions.length === 1 ? renderSubtitleButton() :
    <Dropup
      options={subtitleOptions}
      handleChange={setLang}
      initialSelected={lang}
      customTriggerButton={renderSubtitleButton}
      customLabelRenderFunction={parseSubtitlesType}
      hoverTriggered={true}
    />
}

export { Subtitle as default }
